import { Country } from "@finbackoffice/enums";
import { useEffect, useState } from "react";
import { useRuntimeConfig } from "./useRuntimeConfig";

// Source => https://raw.githubusercontent.com/dr5hn/countries-states-cities-database/refs/heads/master/json/countries%2Bstates.json

// Zip codes Source => https://gist.github.com/jamesbar2/1c677c22df8f21e869cca7e439fc3f5b

export const useCountryStates = (enable: boolean, countryCode: Country) => {
    const COMMON_SITE_CONFIGS = useRuntimeConfig("COMMON_SITE_CONFIGS");
    const supportedCountries = COMMON_SITE_CONFIGS.country.supported;

    const [countryStates, setCountryStates] = useState<{ loading: boolean; states: any[] }>({
        loading: false,
        states: [],
    });

    useEffect(() => {
        /* const loadStates = async (country: Country) => {
            // console.log(AllStates);

            const headers = new Headers();
            headers.append("X-CSCAPI-KEY", StatesAPIToken);

            const requestOptions = {
                method: "GET",
                headers: headers,
                // redirect: "follow",
            };
            const response = await fetch(
                `https://api.countrystatecity.in/v1/countries/${CountryISO2Mapping[country]}/states`,
                requestOptions,
            );
            console.log(response);
        }; */

        const loadStates = async (countryCode: Country) => {
            setCountryStates((state) => ({
                ...state,
                loading: true,
            }));
            try {
                const response = await fetch(`/api/country-states?country=${countryCode}`);

                if (!response.ok) {
                    throw new Error("Failed to fetch states");
                }

                const countryStates = await response.json();
                setCountryStates({
                    states: countryStates.items,
                    loading: false,
                });
            } catch (error: unknown) {
                console.error("Error fetching states:", error);
                setCountryStates((state) => ({
                    ...state,
                    loading: false,
                }));
            }
        };

        if (enable && supportedCountries.includes(countryCode)) {
            loadStates(countryCode as Country);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [countryCode]);

    return countryStates;
};
